<template>
  <div class="container-fluid">
    <tab></tab>
    <neck ref="neck"></neck>

    <div class="hidden-xs hidden-sm">
      <div class="partner-footer" style="padding-top:0.55rem;">
        <div class="partner-footer-center">
          <div class="footer-center-top spaceBetween" style="align-items: flex-start;">
            <img :src="global.urlInfo.queryUrl+'/storage/'+newsInfo.pic_zh" alt="#" class="center-top-img"/>
            <div class="center-top-right">
              <div class="index-foot-title start">{{type==1?newsInfo.title_zh:newsInfo.title}}</div>
              <div class="index-foot-tips start">{{type==1?newsInfo.summary_zh:newsInfo.summary}}</div>
              <div class="top-right-bottom start">{{newsInfo.created_at.slice(0,10)}}</div>
            </div>
          </div>
          <div class="index-foot-center" v-html="type==1?newsInfo.description_zh:newsInfo.description"></div>
        </div>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-partner-footer" style="padding-top:0.55rem;">
        <!-- <div class="footer-center-top spaceBetween" style="align-items: flex-start;">
          <img :src="global.urlInfo.queryUrl+'/storage/'+newsInfo.pic_zh" alt="#" class="center-top-img"/>
          <div class="phoneCenter-top-right">
            <div class="index-foot-titlePhone start">{{type==1?newsInfo.title_zh:newsInfo.title}}</div>
            <div class="index-foot-tips start">{{type==1?newsInfo.summary_zh:newsInfo.summary}}</div>
            <div class="top-right-bottom start">{{newsInfo.created_at.slice(0,10)}}</div>
          </div>
        </div> -->
        <div class="index-foot-titlePhone middle">{{type==1?newsInfo.title_zh:newsInfo.title}}</div>
        <div class="index-foot-center" style="padding-left:0;padding-right:0;" v-html="type==1?newsInfo.description_zh:newsInfo.description"></div>
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab.vue';
import neck from '@/components/neck.vue';
import footerBar from '@/components/footerBar.vue';
import Swiper from 'swiper';
import axios from 'axios';
import {format} from '@/utils/util.js';
import { setTimeout } from 'timers';
export default {
  name: 'Home',
  components: {
    tab:tab,
    footerBar:footerBar,
    neck:neck
  },
  data () {
    return {
      mySwiper:null,
      mySwiperPhone:null,
      page:1,
      type:1,
      pageList:[],
      newsInfo:{}
    }
  },
  methods:{
    windowOpen(url){
      const vm=this
      window.open(url)
    },
    goUp(){
      const vm=this
      vm.mySwiper.slidePrev();
    },
    goDown(){
      const vm=this
      vm.mySwiper.slideNext();
    },
    queryNewsInfo(){
      const vm=this
      let obj = {
        id:vm.$route.query.id
      }
      axios.get(`${vm.global.urlInfo.queryUrl}/api/monday/news_detail/${obj.id}`).then(data=>{
        if(data&&data.data&&data.data.code==1){
          vm.newsInfo = data.data.data
          console.log('data*****----****')
          console.log(vm.newsInfo)
          //输出到页面详情中
        }
      })
    },
    choiceType(num){
      const vm=this
      vm.type = localStorage.getItem('ssType') || Number(num)
      vm.$refs.neck.setType(vm.type,5)
      vm.$refs.neck.setPageTips({
        site_name:'蔬适周一，舒适一周！',
        site_name_en:'Meatless Monday',
      })
      vm.$refs.footerView.setType(vm.type)
    }
  },
  created () {
    
  },
  mounted(){
    const vm=this
    vm.queryNewsInfo()
    vm.choiceType(1)
  }
}
</script>
<style scoped>
/**  首页banner web  **/
.container-fluid{
  width: 100%;
  padding: 0;
  margin: 0;
}

/** web 合作伙伴 **/
.partner-footer{
  padding: 0 0.5rem 0.375rem;
  height: auto;
  /* background: #f5f8ef; */
}
.partner-footer-center{
  padding: 0.5rem 0 0;
  height: auto;
}
.center-top-img{
  width: 50%;
  height: 2.13rem;
  object-fit: cover;
}
.center-top-right{
  padding-left: 0.1rem;
  width: 50%;
  height: 2.13rem;
  position: relative;
}
.index-foot-title{
  font-size: 0.24rem;
  color: #333;
  text-align: left;
  line-height: 1.4;
  margin-bottom: 0.06rem;
  font-family:'huangyou';
  margin-top: -0.08rem;
}
.index-foot-tips{
  font-size: 16px;
  color: #333;
  line-height: 1.4;
  text-align: left;
}
.top-right-bottom{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-left: 0.1rem;
  font-size: 14px;
  color: #717171;
  text-align: left;
}
.index-foot-center{
  padding: 0.4rem 1.4rem;
}


/** phone 合作伙伴 **/
.phone-partner-footer{
  padding: 0.75rem 0.5rem;
  height: auto;
  /* background: #f5f8ef; */
}
.index-foot-titlePhone{
  font-size: 0.52rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
}

.index-foot-center>img{
  width: 100%;
  height: auto;
}
</style>

